import * as React from 'react'

export enum TimelineStepPosition {
  First = 'First',
  Between = 'Between',
  Last = 'Last',
}

export enum TimelineStepState {
  Neutral = 'Neutral',
  Current = 'Current',
  Completed = 'Completed',
}

export interface WrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Optional class name for custom styling */
  className?: string
}

export interface StepProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  /** Position of the step within the timeline sequence */
  position: TimelineStepPosition
  /** Visual state of the step marker and track */
  state: TimelineStepState
  /** Title text shown for the step */
  title: string
  /** Optional subtitle text shown below the title */
  overline?: string
  /** Optional body text shown below the subtitle. Ignored when `children` is provided */
  text?: string
  /** Optional custom content rendered instead of `text` */
  children?: React.ReactNode
  /** Optional class name for custom styling */
  className?: string
}
